import { LitElement } from "lit-element";
import { html, render } from "lit-html";

/**
 * Show/hide list elements
 * @property {Boolean} isOpen state of component
 * @property {Array} closedNum number of elements to show when closed
 * @property {Array} openNum number of elements to show when open
 * @property {Array} items list elements to be displayed
 * @property {Function} listTemplate describes how each list item should be displayed
 */
class KbViewMore extends LitElement {
  static get properties() {
    return {
      isOpen: { type: Boolean },
      closedNum: { type: Number },
      openedNum: { type: Number },
      items: { type: Array },
      template: { type: Function },
    };
  }

  constructor() {
    super();
    this.isOpen = false;
    this.closedNum = 0;
  }

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  resultsTemplate() {
    if (this.isOpen) {
      return html` ${this.items
        .slice(0, this.openedNum)
        .map((item) => this.template(item))}`;
    } else {
      return html`${this.items
        .slice(0, this.closedNum)
        .map((item) => this.template(item))}`;
    }
  }

  captionTemplate() {
    if (this.items.length > 1) {
      if (this.isOpen) {
        return html`<button @click=${this.handleClick} class="view-more-btn">
          Show less <iron-icon icon="vaadin:angle-up"></iron-icon>
        </button>`;
      } else {
        return html`<button @click=${this.handleClick} class="view-more-btn">
          View more <iron-icon icon="vaadin:angle-down"></iron-icon>
        </button>`;
      }
    }
  }

  render() {
    if (this.items.length > 0) {
      return html`
      <style>
        .view-list-container {
            list-style: none;
            padding: 0;
        }  
        
        .view-more-btn {
          display: block;
          position: relative;
          z-index: 100;
          opacity: 59%;
          background: none;
          text-align: left;
          padding: 0;
          border: none;
          font-size: 0.9125rem;
          margin: 0 0 0 0.1rem;
          width: 100%;
        }

        iron-icon {
            width: 0.9125rem;
        }
        </style>
        <ul class="view-list-container" part="view-list">
          ${this.resultsTemplate()}
        </ul>
        ${this.captionTemplate()}
      `;
    }
  }

  createRenderRoot() {
    return this;
  }
}

customElements.define("kb-view-more", KbViewMore);
